import styled from "styled-components";
import {Card} from "antd";

export const StyledUpcomingCallCard = styled(Card)`
  border: 1px solid #f0f0f0;
  border-radius: 8px;
`;

export const StyledUpcomingCallCardMetaInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 1.6rem;
  flex-wrap: wrap;
`;
export const StyledModalContentWrapper = styled.div`
  padding: 1.6rem 2.4rem;
  /* background-color: #f5f5f5; */
  background-color: #fff;
  .footer-buttons {
    display: flex;
    justify-content: space-between;
    margin-top: 4rem;
  }
  .footer-buttons button {
    width: 49%;
  }
  @media (max-width: 500px) {
    .footer-buttons {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-top: 4rem;
      gap: 1rem;
    }
    .footer-buttons button {
      width: 100%;
    }
  }
  .footer-button {
    display: flex;
    justify-content: center;
    margin-top: 4rem;
  }
  .footer-button button {
    width: 100%;
  }
  .ant-modal-footer {
    padding: 0;
  }
`;
export const StyledModalContentInfo = styled.div`
  font-size: 1.4rem;
  .content-heading {
    font-weight: 500;
  }
  .content-text {
    font-weight: 400;
    margin-top: 1rem;
  }
  .splash-screen-title {
    margin-bottom: 2rem;
    font-size: 24px;
  }
  @media (max-width: 500px) {
    .splash-screen-title {
      margin-bottom: 2rem;
      font-size: 16px;
    }
  }
  .splash-screen-title img {
    width: 15%;
  }
`;
export const StyledCardDetailsButtonWrapper = styled.div`
  display: flex;
  // align-items: center;
  gap: 1rem;

  @media (max-width: 500px) {
    margin-top: 1.3rem;
    flex-direction: column;
  }
`;
export const StyleDrawerInfoBlock = styled.div`
  border: 1px solid #ffe58f;
  background-color: #fffbe6;
  padding: 9px 1.6rem;
  color: #d48806;
`;
export const StyledCardCTAButtonWrapper = styled.div`
  display: flex;
  gap: 1rem;

  @media (max-width: 500px) {
    flex-direction: column;
  }
`;
